export default __webpack_public_path__ + "static/media/moonbar-sideways.cb94f0bd.png";